import { db } from '../firebase';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';

/**
 * Send booking enquiry to Firestore in a hierarchical structure
 * Structure: bookingEnquiries (collection) > Year (document) > Month (map) > Date (map) > EnquiryId (map) > data
 * This reduces read operations by organizing data efficiently
 * 
 * Also sends email notification using FormSubmit
 */
export const sendBookingEnquiry = async (enquiryData) => {
  try {
    // Generate a unique ID for the enquiry
    const enquiryId = `enq_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
    
    // Get current date info for structuring
    const now = new Date();
    const year = now.getFullYear().toString();
    const month = (now.getMonth() + 1).toString().padStart(2, '0'); // 01-12
    const date = now.getDate().toString().padStart(2, '0'); // 01-31
    
    // Add server timestamp and enquiry ID
    const dataWithTimestamp = {
      ...enquiryData,
      createdAt: serverTimestamp(),
      enquiryId: enquiryId,
      status: 'new', // Default status for new enquiries
      source: 'property_page' // Track source of enquiry
    };
    
    // Create the document path with the hierarchical structure
    const docRef = doc(db, 'bookingEnquiries', year);
    
    // Set the document with a nested structure using merge to preserve existing data
    await setDoc(docRef, {
      [month]: {
        [date]: {
          [enquiryId]: dataWithTimestamp
        }
      }
    }, { merge: true });
    
    // console.log('Booking enquiry saved successfully with ID:', enquiryId);
    
    // Send email notification using FormSubmit if formRef is provided
    // This will be handled by the calling component
    
    return { success: true, enquiryId };
    
  } catch (error) {
    console.error('Error saving booking enquiry:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Send booking enquiry email using FormSubmit
 */
export const sendBookingEnquiryEmail = async (formData, formRef) => {
  try {
    if (!formRef || !formRef.current) {
      throw new Error('Form reference is required for email submission');
    }
    
    // Create FormData object for email submission
    const formElement = formRef.current;
    const formDataObj = new FormData(formElement);
    
    // Add subject line for better context
    formDataObj.append('_subject', 'New Booking Enquiry - LSQ Stays');
    
    // Send the form data to FormSubmit
    const emailResponse = await fetch('https://formsubmit.co/info@lsqstays.com', {
      method: 'POST',
      body: formDataObj,
      headers: {
        'Accept': 'application/json'
      }
    });
    
    if (!emailResponse.ok) {
      console.warn("Email delivery may have failed:", emailResponse.statusText);
      return { success: false, error: 'Email delivery failed' };
    }
    
    return { success: true };
    
  } catch (error) {
    console.error('Error sending booking enquiry email:', error);
    return { success: false, error: error.message };
  }
};
